import { render, staticRenderFns } from "./TagGroup.vue?vue&type=template&id=c3fa6bf2"
import script from "./TagGroup.vue?vue&type=script&lang=js"
export * from "./TagGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports